export const routes = {
    DEFAULT: '/accounts',
    PARTNER_INTEGRATIONS: '/partner-integrations',
    CLIENT_METRICS: '/client-metrics',
    INBOUND_CONNECTIONS: '/inbound-connections',
} as const;
